var _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 61,
    viewBox: "0 0 380 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 243.353,
    cy: -34.6146,
    rx: 136.647,
    ry: 95.6146,
    transform: "rotate(180 243.353 -34.6146)",
    fill: "#4C862E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 137.353,
    cy: -60.806,
    rx: 136.647,
    ry: 95.6146,
    transform: "rotate(180 137.353 -60.806)",
    fill: "#4C862E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperDesign);
export default __webpack_public_path__ + "static/media/UpperDesign.a1263326bea26e3766b8d9c7edb441b0.svg";
export { ForwardRef as ReactComponent };